import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _JSON$stringify from "@babel/runtime-corejs3/core-js/json/stringify";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import { defineComponent, reactive, onMounted, ref, onUnmounted, nextTick } from "@vue/composition-api";
import * as FieldComponents from "@Shared/components/sections/index";
import { formatMoneyValueLong } from "@Shared/@Utils/helpers/money";
import MortgageAmschedule from "./mortgage-amschedule.vue";
import MortgageCalculatorsToolbar from "./mortgage-calculators-toolbar.vue";
import ReportTabLayout from "@Broker/@Modules/clients/reports/reports-containers/report-tab-layout.vue";
import { MORTGAGE_FREQUENCY } from "@Shared/@Types/application/application-enums";
import { APPLICATION_FIELD_OPTIONS } from "@Shared/@Utils/application-defaults-utils/global-field-options";
import { showToast } from "@Shared/@Utils/constants";
import i18n from "@Shared/i18n";
import { toNumber } from "lodash";
import { CALCULATOR_FORMS } from "@Broker/@Types/financial-tools/types";
import { defaultPrintAction } from "../store/financial-tools-actions";
const componentName = "PrepaymentAnalyzerContainer";
export default defineComponent({
  name: componentName,
  components: _objectSpread(_objectSpread({}, FieldComponents), {}, {
    MortgageAmschedule,
    MortgageCalculatorsToolbar,
    ReportTabLayout
  }),
  setup() {
    const thisComponentCookieString = localStorage.getItem(componentName);
    const thisComponentCookieData = thisComponentCookieString ? JSON.parse(thisComponentCookieString) : {};
    const inoudata = reactive({
      showAMsched: false,
      doHideAMsched: () => {
        inoudata.showAMsched = false;
      },
      frequency: thisComponentCookieData.frequency || MORTGAGE_FREQUENCY.MONTHLY,
      amortizPeriodMths: thisComponentCookieData.amortizPeriodMths || 300,
      mortgageAmount: thisComponentCookieData.mortgageAmount || 0,
      interestRate: thisComponentCookieData.interestRate || 0.0001,
      PandI: thisComponentCookieData.PandI || 0,
      lumpAmt: thisComponentCookieData.lumpAmt || 0,
      lumpYears: thisComponentCookieData.lumpYears || 1,
      incpayValue: thisComponentCookieData.incpayValue || 0,
      incYears: thisComponentCookieData.incYears || 1,
      incpayType: thisComponentCookieData.incpayType || "",
      revamortizPeriodMths: thisComponentCookieData.revamortizPeriodMths || 0,
      interestSavings: thisComponentCookieData.interestSavings || 0,
      intFact: 0,
      baseRevAm: 0,
      timeKind: 0,
      numPay2: 0,
      whatyear: 0
    });
    const {
      mortgageFrequencyOptions
    } = APPLICATION_FIELD_OPTIONS();
    function retFreq(useDaysInYear) {
      const payFreq = inoudata.frequency;
      const numD = useDaysInYear == 2 ? 365.25 : 365;
      switch (payFreq) {
        default:
          return 12;
        case MORTGAGE_FREQUENCY.SEMI_MONTHLY:
          return 24;
        case MORTGAGE_FREQUENCY.BIWEEKLY:
          return 365.25 / 14;
        case MORTGAGE_FREQUENCY.ACCELERATED_BIWEEKLY:
          return numD / 14;
        case MORTGAGE_FREQUENCY.WEEKLY:
          return 365.25 / 7;
        case MORTGAGE_FREQUENCY.ACCELERATED_WEEKLY:
          return numD / 7;
      }
    }
    const handleClearSelection = () => {
      inoudata.frequency = MORTGAGE_FREQUENCY.MONTHLY;
      inoudata.showAMsched = false;
      inoudata.mortgageAmount = 0;
      inoudata.interestRate = 0;
      inoudata.amortizPeriodMths = 300;
      inoudata.PandI = 0;
      inoudata.lumpAmt = 0;
      inoudata.lumpYears = 1;
      inoudata.incpayValue = 0;
      inoudata.incYears = 1;
      inoudata.incpayType = "$";
      inoudata.revamortizPeriodMths = 0;
      inoudata.interestSavings = 0;
    };
    onMounted(() => {
      $("[name='mortgageAmount']").trigger("focus");
    });
    onUnmounted(() => {
      localStorage.setItem(componentName, _JSON$stringify(inoudata));
    });
    function formatVal(val) {
      return val.toLocaleString();
    }
    function roundPen(val, decs) {
      const fact = 10 ** decs;
      return val > 0 ? Math.round(val * fact) / fact : 0;
    }
    function roundReg(n) {
      return roundPen(n, 2);
    }
    function calcPay(mortgage, intfact, compfact) {
      return roundReg(mortgage * intfact * compfact / (compfact - 1));
    }
    function calcIntFact(intrate, compfreq, numpay1) {
      return Math.pow(1 + intrate / compfreq, compfreq / numpay1) - 1;
    }
    function calcCompFact(amort, intfact, numpay2) {
      const amortPays = Math.floor(amort / 12 * numpay2);
      return Math.pow(1 + intfact, amortPays);
    }
    function calcBal(mortgage, intfact, payment, whatPay) {
      return roundReg(mortgage * Math.pow(1.0 + intfact, whatPay) - payment * (Math.pow(1.0 + intfact, whatPay) - 1.0) / intfact);
    }
    function calcAccelPay(payment, numpay1) {
      return roundReg(payment * 13 / Math.floor(numpay1));
    }
    function calcReverseAccel(payment, numpay1) {
      return roundReg(payment * Math.floor(numpay1) / 13);
    }
    function calcAmort(mortgage, payment, intfact) {
      return Math.round(Math.log(payment / (payment - mortgage * intfact)) / Math.log(1 + intfact));
    }
    function calcMtgAmount(intfact, payment, whatPay) {
      return roundReg(payment * (Math.pow(1.0 + intfact, whatPay) - 1) / (intfact * Math.pow(1.0 + intfact, whatPay)));
    }
    function calcRate(mortgage, amortMon, numPay1, numPay2, payment) {
      if (amortMon == 0) return 0;
      let lowgs = 0;
      let highgs = 99;
      let solvePay = 0;
      let newRate = 0;
      let gsRate = (highgs + lowgs) / 2;
      let chkDif = 10;
      let chkPay = 10;
      for (gsRate; chkDif >= 0.001 || chkPay >= 0.01 && gsRate >= 0.0001; gsRate = (highgs + lowgs) / 2) {
        const intFact = calcIntFact(gsRate / 100, 2, numPay1);
        const compFact = calcCompFact(amortMon, intFact, numPay2);
        solvePay = calcPay(mortgage, intFact, compFact);
        if (solvePay < payment) {
          lowgs = gsRate;
          chkPay = roundReg(payment - solvePay);
        } else {
          highgs = gsRate;
          chkPay = roundReg(solvePay - payment);
        }
        newRate = (highgs + lowgs) / 2;
        if (gsRate > newRate) {
          chkDif = gsRate - newRate;
        } else {
          chkDif = newRate - gsRate;
        }
        if (chkDif < 0.001 || chkPay < 0.01) {
          break;
        }
      }
      return gsRate;
    }
    function computeResults(mode, whatyear) {
      const mortgage = toNumber(inoudata.mortgageAmount);
      const intRate = toNumber(inoudata.interestRate) / 100;
      const paymentx = toNumber(inoudata.PandI);
      let payment = paymentx;
      const numPay1 = retFreq(1);
      const numPay2 = retFreq(2);
      const compFreq = 2;
      const intFact = calcIntFact(intRate, compFreq, numPay1);
      const baseRevAm = calcAmort(mortgage, payment, intFact);
      const regIntBal = calcBal(mortgage, intFact, payment, baseRevAm);
      const regularInterest = payment * baseRevAm - (mortgage - regIntBal);
      const lumpAmt = toNumber(inoudata.lumpAmt);
      const lumpTime = toNumber(inoudata.lumpYears);
      const incpayAmt = toNumber(inoudata.incpayValue);
      const incpayType = inoudata.incpayType;
      const incpayTime = toNumber(inoudata.incYears);
      let principalBal = mortgage;
      let prepayInterest = 0;
      let annualCount = 1;
      let aYear = 0;
      let payAdd;
      let newPayAdd = 0;
      let realPayment = 0;
      for (payAdd = 1; principalBal > 0 && payAdd <= baseRevAm; payAdd++) {
        if (payAdd / Math.floor(numPay1) == annualCount) {
          aYear = 1;
        }
        if (aYear == 1 && incpayTime >= annualCount) {
          payment = incpayType == "%" ? roundReg((1.0 + incpayAmt / 100) * payment) : payment + incpayAmt;
        }
        const interestPayment = roundReg(principalBal * intFact);
        const principalPayment = roundReg(payment - interestPayment);
        const checkBal = Math.min(principalBal, principalPayment);
        principalBal = roundReg(principalBal - checkBal);
        if (aYear == 1 && lumpTime >= annualCount) {
          const checkLump = lumpAmt > principalBal ? principalBal : lumpAmt;
          principalBal = roundReg(principalBal - checkLump);
        }
        prepayInterest = roundReg(prepayInterest + interestPayment);
        realPayment = roundReg(interestPayment + checkBal);
        if (principalBal <= 0) {
          newPayAdd = payAdd;
        }
        if (aYear == 1) {
          annualCount++;
          aYear = 0;
        }
      }
      if (principalBal > 0) {
        newPayAdd = baseRevAm;
      }
      if (realPayment < payment / 2) {
        --newPayAdd;
      }
      const revAmortMon = Math.round(newPayAdd / numPay2 * 12);
      const savedInterest = roundReg(regularInterest - prepayInterest);
      inoudata.revamortizPeriodMths = revAmortMon;
      if (inoudata.lumpAmt * inoudata.lumpYears > 0 || inoudata.incpayValue * inoudata.incYears > 0) {
        inoudata.interestSavings = savedInterest;
      } else {
        inoudata.interestSavings = 0;
      }
      if (mode == 2) {
        let timeKind;
        if (whatyear == -1) {
          timeKind = 0;
        } else {
          whatyear = 0;
          timeKind = 1;
        }
        inoudata.intFact = intFact;
        inoudata.baseRevAm = baseRevAm;
        inoudata.numPay2 = numPay2;
        inoudata.timeKind = timeKind;
        inoudata.whatyear = whatyear;
      }
      return true;
    }
    function isValidItem(val, min, max, keyname, msgTag, name, formater) {
      min = Number(min);
      max = Number(max);
      if (val >= min && val <= max) return true;
      let msgl = i18n.t(keyname) + ": ";
      const msg = msgTag ? i18n.t(msgTag) : i18n.t("financial-tools.message_missing_questionRange") + formater(min) + ", " + formater(max) + "]";
      msgl += msg;
      showToast("error", msgl);
      $("[name='" + name + "']").trigger("focus");
      return false;
    }
    function isValidmortgageAmount() {
      return isValidItem(inoudata.mortgageAmount, 10000, 100000000, "financial-tools.mortgage_amount", "financial-tools.message_missing_question_1", "mortgageAmount", formatMoneyValueLong);
    }
    function isValidinterestRate() {
      return isValidItem(inoudata.interestRate, 0.001, 100.0, "financial-tools.interest_rate", "financial-tools.message_missing_question_2", "interestRate", formatVal);
    }
    function isValidamortizPeriodMths() {
      return isValidItem(inoudata.amortizPeriodMths, 1, 35 * 12, "financial-tools.amortization_period", "financial-tools.message_missing_question_3", "amortizPeriodMths", formatVal);
    }
    function isValidPandI() {
      return isValidItem(inoudata.PandI, 1, 100000000, "financial-tools.mortgagePayment", "financial-tools.message_missing_question100M", "PAndI", formatMoneyValueLong);
    }
    function isValidPrepay() {
      let isValid = isValidItem(inoudata.lumpAmt, 0, inoudata.mortgageAmount, "financial-tools.lumpSumPayment", null, "lumpAmt", formatMoneyValueLong);
      if (!isValid) return false;
      isValid = isValidItem(inoudata.lumpYears, 0, 99, "financial-tools.lumpSumPayment", null, "lumpYears", formatVal);
      if (!isValid) return false;
      const isPercent = inoudata.incpayType == "%";
      isValid = isValidItem(inoudata.incpayValue, 0, isPercent ? 999 : inoudata.mortgageAmount, "financial-tools.mortgagePaymentIncrease", null, "incpayValue", isPercent ? formatVal : formatMoneyValueLong);
      if (!isValid) return false;
      isValid = isValidItem(inoudata.incYears, 0, 99, "financial-tools.mortgagePaymentIncrease", null, "incYears", formatVal);
      if (!isValid) return false;
      return true;
    }
    function validResults(calcField) {
      if (calcField != 0 && !isValidmortgageAmount()) {
        return false;
      }
      if (calcField != 1 && !isValidinterestRate()) {
        return false;
      }
      if (calcField != 2 && !isValidamortizPeriodMths()) {
        return false;
      }
      if (calcField != 3 && !isValidPandI()) {
        return false;
      }
      if (!isValidPrepay()) {
        return false;
      }
      return true;
    }
    function calcMortgage(calcField) {
      if (!validResults(calcField)) return false;
      let mortgage = toNumber(inoudata.mortgageAmount);
      let intRate = toNumber(inoudata.interestRate) / 100;
      let amortMon = toNumber(inoudata.amortizPeriodMths);
      let payment = toNumber(inoudata.PandI);
      const payFreq = inoudata.frequency;
      const compFreq = 2;
      const numPay1 = retFreq(1);
      const numPay2 = retFreq(2);
      const isAccel = payFreq == MORTGAGE_FREQUENCY.ACCELERATED_BIWEEKLY || payFreq == MORTGAGE_FREQUENCY.ACCELERATED_WEEKLY;
      let intFact;
      let paym;
      let amortm;
      let numpay;
      if (calcField == 0) {
        if (isAccel) {
          paym = calcReverseAccel(payment, numPay1);
          amortm = amortMon;
          numpay = 12;
        } else {
          paym = payment;
          amortm = Math.floor(amortMon / 12 * numPay2);
          numpay = numPay1;
        }
        intFact = calcIntFact(intRate, compFreq, numpay);
        mortgage = calcMtgAmount(intFact, paym, amortm);
        inoudata.mortgageAmount = roundReg(mortgage);
      } else if (calcField == 1) {
        if (isAccel) {
          paym = calcReverseAccel(payment, numPay1);
          intRate = calcRate(mortgage, amortMon, numPay1, numPay2, paym);
        } else {
          intRate = calcRate(mortgage, amortMon, numPay1, numPay2, payment);
        }
        inoudata.interestRate = Math.round(intRate * 1000) / 1000;
      } else if (calcField == 2) {
        if (isAccel) {
          paym = calcReverseAccel(payment, numPay1);
          numpay = 12;
        } else {
          paym = payment;
          numpay = numPay2;
        }
        intFact = calcIntFact(intRate, compFreq, numpay);
        amortm = calcAmort(mortgage, paym, intFact);
        const initAmortMon = Math.round(amortm / numpay * 12);
        inoudata.amortizPeriodMths = initAmortMon;
      } else if (calcField == 3) {
        if (isAccel) {
          const monIntFact = calcIntFact(intRate, compFreq, 12);
          const monCompFact = calcCompFact(amortMon, monIntFact, 12);
          const monPayment = calcPay(mortgage, monIntFact, monCompFact);
          payment = calcAccelPay(monPayment, numPay1);
        } else {
          intFact = calcIntFact(intRate, compFreq, numPay1);
          const compFact = calcCompFact(amortMon, intFact, numPay2);
          payment = calcPay(mortgage, intFact, compFact);
        }
        inoudata.PandI = roundReg(payment);
      }
      return true;
    }
    function controlMortgage(mode) {
      inoudata.showAMsched = false;
      const isValid = calcMortgage(3);
      if (isValid && mode == 1) {
        computeResults(1, 0);
      }
      return isValid;
    }
    function amortLink(whatyear) {
      inoudata.showAMsched = validResults(-1) && computeResults(2, whatyear);
    }
    const isLoading = ref(false);
    const loadingSucceeded = ref(true);
    const runReport = async () => {
      isLoading.value = true;
      loadingSucceeded.value = true;
      controlMortgage(1);
      amortLink(-1);
      await nextTick();
      const data = {
        paymentFrequency: inoudata.frequency,
        mortgageAmount: inoudata.mortgageAmount,
        interestRate: inoudata.interestRate,
        amortizationPeriod: inoudata.amortizPeriodMths,
        PandI: inoudata.PandI,
        paymentIncreaseType: inoudata.incpayType,
        lumpSumAmount: inoudata.lumpAmt,
        lumpSumPeriod: inoudata.lumpYears,
        paymentIncreaseAmount: inoudata.incpayValue,
        paymentIncreasePeriod: inoudata.incYears,
        revisedAmortizationPeriod: inoudata.revamortizPeriodMths,
        savings: inoudata.interestSavings,
        amSchedule: amScheduleData.value
      };
      try {
        await defaultPrintAction({
          type: CALCULATOR_FORMS.PREPAYMENT_ANALYZER,
          data
        });
      } catch (e) {
        loadingSucceeded.value = false;
        console.error(e);
      }
      isLoading.value = false;
    };
    const amScheduleData = ref(null);
    const generatedAmSchedule = data => {
      amScheduleData.value = data;
    };
    return {
      inoudata,
      mortgageFrequencyOptions,
      formatMoneyValueLong,
      amortLink,
      controlMortgage,
      calcMortgage,
      handleClearSelection,
      runReport,
      isLoading,
      loadingSucceeded,
      generatedAmSchedule
    };
  }
});